import axios, {
  AxiosRequestHeaders,
  type AxiosRequestConfig,
  type AxiosResponse,
  type InternalAxiosRequestConfig,
} from 'axios';
import type { SafeAny } from '@trg/utils';
import { isNil } from 'lodash-es';

interface requestDataType {
  [key: string]: SafeAny;
}
export interface RequestConfigExtra {
  devHost?: boolean;
  token?: boolean;
  loading?: boolean;
  onStart?: () => void;
  onEnd?: () => void;
}

function isFormUrlEncoded(headers: AxiosRequestHeaders) {
  const contentType = headers['Content-Type'] || headers['content-type'];
  return /application\/x-www-form-urlencoded/i.test(contentType);
}

const instance = axios.create();

function requestHandler(
  config: InternalAxiosRequestConfig & RequestConfigExtra
) {
  // 处理请求前的 url
  if (
    process.env['NX_TASK_TARGET_CONFIGURATION'] === 'development' &&
    config.devHost
  ) {
    // 设置开发环境的 baseUrl
    config.baseURL = process.env['TLW_API_HOST'];
  }

  if (config.token) {
    config.data = {
      ...config.data,
      CSRFToken: window['CSRFToken' as keyof Window],
    };
  }

  if (isFormUrlEncoded(config.headers)) {
    const payload = new URLSearchParams();
    Object.entries(config.data as requestDataType).forEach(([key, value]) => {
      !isNil(value) && payload.append(key, value);
    });
    config.data = payload;
  }

  return config;
}

function responseHandler(response: AxiosResponse) {
  return response.data;
}

instance.interceptors.request.use(requestHandler);

instance.interceptors.response.use(responseHandler);

export default instance;

export function request<R = SafeAny, P = SafeAny>(
  options: AxiosRequestConfig<P> & RequestConfigExtra
): Promise<R> {
  return new Promise((resolve, reject) => {
    const { onStart, onEnd } = options;
    onStart?.();
    instance
      .request<R, R, P>(options)
      .then(resolve)
      .catch(reject)
      .finally(onEnd);
  });
}
